;(() => {
  document.querySelectorAll('.menu-toggle-open').forEach((element) => {
    element.addEventListener('click', function () {
      document.getElementsByTagName('HTML')[0].classList.add('menu-open')
    })
  })

  document
    .querySelectorAll('.menu-toggle-close, #menu-background')
    .forEach((element) => {
      element.addEventListener('click', function () {
        document.getElementsByTagName('HTML')[0].classList.remove('menu-open')
      })
    })
})()
